
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";
import { Getter } from "vuex-class";

export interface ICard {
  title: string;
  valueKey: string;
  visible: boolean;
  sortNum?: number;
}

@Component({
  name: "settingCard",
  components: {
    draggable,
  },
})
export default class SettingCard extends Vue {
  @Getter isMultiStore!: boolean;
  @Prop({
    default: () => {
      [];
    },
  })
  cardList?: ICard[];
  options: ICard[] = [];
  cardDataSort: number[] = [];

  defaultIndex = 1;
  show = false;

  openPop() {
    //单门店显示["会员分析","收银对账","交易明细"]  多门店显示"多店核心"
    const cardData = JSON.parse(JSON.stringify(this.cardList));
    if (this.isMultiStore) {
      this.options = cardData.filter(
        (item) => !["会员分析", "收银对账", "交易明细"].includes(item.title)
      );
    } else {
      this.options = cardData.filter((item) => item.title !== "多店核心");
    }
    // 记录第一次的sortNum
    this.cardDataSort = this.options.map((item, index) => item.sortNum);
    this.show = true;
  }
  popupClose() {
    this.show = false;
  }

  confirmFn() {
    // 还原真实的sortNum
    this.options.forEach((item, index) => {
      item.sortNum = this.cardDataSort[index];
    });
    const cardData = JSON.parse(JSON.stringify(this.cardList));
    cardData.forEach((item) => {
      const curItem = this.options.find((o) => o.title === item.title);
      if (curItem) {
        item.sortNum = curItem.sortNum;
        item.visible = curItem.visible;
      }
    });
    cardData.sort((a, b) => Number(a.sortNum) - Number(b.sortNum));
    this.$emit("confirm", cardData);
    this.popupClose();
  }

  @Watch("show", { immediate: true })
  onChangeShow() {
    this.changeNativeAreaColor(this.show);
  }

  changeNativeAreaColor(show: boolean) {
    const params = {
      bottomColor: show ? "#f7f8fa" : "ffffff", // 底部安全区颜色
    };
    this.$bridge.callHandler("changeNativeAreaColor", params, (res) => {});
  }
}
